module.exports = __webpack_public_path__ + "media/images/gift-thanks-writer-bg-ramen@3x-c168ee07c75134aa18b18d1679ace7b8.png";